import { render, staticRenderFns } from "./TrangTaoChucVu.vue?vue&type=template&id=63e29267&"
import script from "./TrangTaoChucVu.vue?vue&type=script&lang=js&"
export * from "./TrangTaoChucVu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports